export default __webpack_public_path__ + "images/funcionarios-ico-hover.svg";